import { isElementInView } from './helpers';

// trees animation
const trees = document.querySelectorAll('.js-counter-tree');
// const treesSection = document.querySelector('.trees');
function animateTrees() {
  trees.forEach((el) => {
    const transformVal = el.getAttribute('data-transform');
    const transDelay = el.getAttribute('data-delay');
    el.style.cssText = `-webkit-transition-delay : ${transDelay}; -o-transition-delay : ${transDelay}; transition-delay : ${transDelay};` //eslint-disable-line
    if (isElementInView(el)) {
      el.setAttribute('transform', transformVal);
    }
  });
}

// trees counter animation

const elNumber = document.querySelector('.js-counter-number');
let elNumH;
// let elNumW;
let flag = 0;


function animateTreeCounter() {
  const elDigits = document.querySelectorAll('.js-counter-number > span');
  let count = elDigits.length;

  function counterAnimation() {
    count -= 1;
    elDigits[count].style.cssText = `-webkit-transform : translate(0,${-elNumH}px);-ms-transform : translate(0,${-elNumH}px);transform : translate(0,${-elNumH}px)`;

    if (count > 0) {
      setTimeout(counterAnimation, 200);
    }
  }
  counterAnimation();
}

// set numbers sizing
function setSize() {
  elNumH = elNumber.clientHeight / 2;
  // elNumW = Math.ceil(elNumber.clientWidth / times);

  elNumber.style.height = `${elNumH}px`;
  // elNumber.style.width = `${times}px`;

  if (isElementInView(elNumber)) animateTreeCounter();

  // animateTreeCounter();
}

function formatTreesNumber(nbr, idx, length) {
  const place = length - 1 - idx;

  return `<span><span class='dummy-digit'>0</span><span>${nbr}</span></span>${(place !== 0 && place % 3 === 0) ? "<span><span class='comma'>,</span></span>" : ''}`;
}

// set amount of planted trees
function setTrees(amount) {
  const times = Math.max(5, amount.length);

  elNumber.innerHTML = `${amount.split('').map((item, i) => formatTreesNumber(item, i, times)).join('')}`;

  setSize();
}

// estimate amount of planted trees
// function estimateTrees() {
//   const start = new Date(2018, 10); // Nov 2018
//   const now = new Date();
//   const treesPlanted = Math.floor((now.getTime() - start.getTime()) / 2629800000) * 9220;
//   return `${treesPlanted}` || elNumber.textContent;
// }

// get amount of planted trees from the API
function getTrees() {
  flag = 1;
  let data = window.siteInfo.treeCountData || '000000';
  data = data.replaceAll(',', '');
  if (data) {
    data = data.replaceAll(',', '');
    setTrees(`${data}`);
  }
}

if (flag === 0) getTrees();

if (trees) animateTrees();

window.addEventListener('scroll', () => {
  if (trees) {
    animateTrees();
    if (isElementInView(elNumber)) animateTreeCounter();
  }
});
